import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from '@sentry/react';

const { REACT_APP_ENV_LABEL = 'unknown' } = process.env;

Sentry.init({
  dsn: 'https://48cc34e91e1f4f8a8406546daa30e140@o1334154.ingest.sentry.io/4503972246388736',
  integrations: [Sentry.browserTracingIntegration()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: REACT_APP_ENV_LABEL === 'production' ? 1.0 : 0,
  environment: REACT_APP_ENV_LABEL,
});

ReactDOM.render(<App />, document.getElementById('root') as HTMLElement);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
